import { useNotification } from 'admin';
import { useApiEvidenceV1BulkDeleteCreate } from 'api';
import { useState } from 'react';

export const useManageEvidence = ({
  onSuccess,
  showNotification = true,
}: {
  onSuccess?: (evidenceIds?: number[]) => void;
  showNotification?: boolean;
}) => {
  const [selected, setSelected] = useState<number[]>([]);
  const { open } = useNotification();
  const { mutate: deleteEvidence, isPending } = useApiEvidenceV1BulkDeleteCreate({
    mutation: {
      onError: (error) => {
        open?.({
          message: `Failed to delete evidence: ${error}`,
          type: 'error',
        });
      },
      onSuccess: (_, { data }) => {
        if (showNotification) {
          open?.({
            message: `Successfully deleted ${data.evidence_ids.length} files`,
            type: 'success',
          });
        }
        setSelected([]);
        onSuccess?.(data.evidence_ids);
      },
    },
  });
  const deleteSelected = () => deleteEvidence({ data: { evidence_ids: selected } });
  const deleteEvidenceFile = (id: number) => deleteEvidence({ data: { evidence_ids: [id] } });

  return { deleteEvidenceFile, deleteSelected, isPending, selected, setSelected };
};
